/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { PromoteUploadMutationResponse, PromoteUploadPathParams } from "../models/PromoteUpload";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { promoteUpload } from "../axios/promoteUpload";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const promoteUploadMutationKey = () => ["social-export-api", { url: '/upload/:id/promote' }] as const

export type PromoteUploadMutationKey = ReturnType<typeof promoteUploadMutationKey>

export function promoteUploadMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = promoteUploadMutationKey()
        return mutationOptions<PromoteUploadMutationResponse, ResponseErrorConfig<Error>, {id: PromoteUploadPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return promoteUpload(id, config)
          },
        })

}

/**
 * @summary Immediately publish a scheduled upload
 * {@link /upload/:id/promote}
 */
export function usePromoteUpload<TContext>(options: 
{
  mutation?: UseMutationOptions<PromoteUploadMutationResponse, ResponseErrorConfig<Error>, {id: PromoteUploadPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? promoteUploadMutationKey()

          const baseOptions = promoteUploadMutationOptions(config) as UseMutationOptions<PromoteUploadMutationResponse, ResponseErrorConfig<Error>, {id: PromoteUploadPathParams["id"]}, TContext>
          

          return useMutation<PromoteUploadMutationResponse, ResponseErrorConfig<Error>, {id: PromoteUploadPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PromoteUploadMutationResponse, ResponseErrorConfig<Error>, {id: PromoteUploadPathParams["id"]}, TContext>
      
}